const SKELETON_WIDTHS = ['30%', '25%', '20%'] as const;

interface SkeletonRowProps {
  /** Number of skeleton columns to render (max 3). */
  cols?: 1 | 2 | 3;
}

export function SkeletonRow({ cols = 3 }: SkeletonRowProps) {
  const widths = SKELETON_WIDTHS.slice(0, cols);
  return (
    <div className="flex items-center gap-3 px-4 py-3">
      {widths.map((w) => (
        <div key={w} className="h-3.5 animate-pulse rounded bg-secondary" style={{ width: w }} />
      ))}
    </div>
  );
}
